import { defaultTo } from 'lodash';

const defaultToAny = (value, ...defaultValues) => defaultValues.reduce(defaultTo, value);

export default defaultToAny;
